//const displayedMonths = new Set();
//const displayedYears = new Set();
const config = {
    //wsServer: '192.168.96.1:9000',
    wsServer: "wss://wwwV01.fistek.com:443/qtewss",
    proxyHost:"http://61.218.31.100:9000/proxy", //空白表示本機資料
    httpsProxyHost:"https://angel.fistek.com/n0",
    vbServer: "https://www.vbroker.net/newfistek/index.php",
    getData : {
        'stkname':'https://www.vbroker.net/newfistek/index.php/Data/stkname',
        'init'   :'https://www.vbroker.net/newfistek/index.php/Data/initdata2', //交易日,昨收,漲停,跌停,開收盤時間等
        'tick'   :'https://www.vbroker.net/newfistek/index.php/Data/twntick2',
        'his'    :'https://www.vbroker.net/newfistek/index.php/Data/FileSrvData',
    },
    chartOptions : {
        //width: chartContainer.clientWidth, // 设置图表的宽度
        //height: chartContainer.clientHeight, // 设置图表的高度    
        layout: {
            //textColor: 'black',
            //background: { type: 'solid', color: 'white' },
            fontSize: 12, // 设置标签字体大小   
            textColor: 'white',
            background: { type: 'solid', color: 'black' },
            fontFamily: 'Arial', // 设置标签字体        
        },
        //用 chart.timeScale().fitContent() => barspacing,minbarspacing 失效
        timeScale: {  //X軸
            visible: true,  //設置時間軸是否可見。預設值為 true。            
            timeVisible: true,      //顯示時間
            secondsVisible: false,  //是否顯示秒           
            rightOffset: 0,         //右側偏移，避免最右側標籤被切掉, 預設值為 0。
            barSpacing: 10,         //設置相鄰兩個時間點（如蠟燭或標記）之間的間距。預設值為 6。
            minBarSpacing: 5,       //設定最小bar間距，避免過度壓縮
            fixLeftEdge: true,      //鎖定左側邊緣，防止左側標籤被截掉。預設值為 false
            fixRightEdge: true,     // 鎖定右側邊緣，防止右側標籤被截掉
            lockVisibleTimeRangeOnResize:true,  //在調整圖表大小時保持可見的時間範圍不變。預設值為 false。
            rightBarStaysOnScroll: true,    //當滾動圖表時，最右邊的時間點將保持固定,確保右側bar不會因滾動而被截掉。預設值為 false。
            borderVisible: true,            //控制時間軸上邊框是否可見。預設值為 true。
            borderColor: '#2B2B43',         //設置時間軸上邊框的顏色。預設值為 #2B2B43。
            shiftVisibleRangeOnNewBar:false, //新柱條（如蠟燭或條形圖）出現時，圖表將自動移動以保持其可見。預設值為 true。
            rightOffsetMinimalValue: 0,     // 控制時間軸右側偏移量的最小值。預設值為 0。(未測出效果)        
            visibleRange: {     //設定時間軸上可見範圍的開始和結束時間。它是一個包含 from 和 to 屬性的物件 (未測出效果)
                //from: new Date('2024-05-01').getTime() / 1000,  // 開始時間或UNIX時間戳
                //to: new Date('2024-08-07').getTime() / 1000    // 結束時間
                //from: 1720137600,
                //to: 1722902400,
            },
            tickMarkFormatter: (time, tickMarkType, locale) => {  //分鐘
                const date = new Date(time * 1000);
                const hours = date.getUTCHours().toString().padStart(2, '0');
                const minutes = date.getUTCMinutes().toString().padStart(2, '0');
                const seconds = date.getUTCSeconds().toString().padStart(2, '0');
                //return `${hours}:${minutes}:${seconds}`;
                return `${hours}:${minutes}`;
            },
            //tickMarkFormatter: (time, tickMarkType, locale) => {
            //    const date = new Date(time * 1000);
            //    return `${date.getFullYear()}/${('0' + (date.getMonth() + 1)).slice(-2)}`;  //-${('0' + date.getDate()).slice(-2)}
            //},
        },
        rightPriceScale: {  //Y軸
            visible: true,
            drawTicks: true,     //價格刻度
            borderVisible: true,  //蠟燭圖的邊框
            borderColor: '#3C3C3C',
            mode: 1, // 1 表示对数比例  ,0 - normal, 1 - log, 2 - percentage, 3 - indexedTo100
            //position: 'right', // 'right' or 'left'
            priceFormat: {
                type: 'price',  //price/volume/custom(和priceFormatter搭配)
                //precision: 0, //显示的数值精度
                //minMove: 0.01,
            }, 
            scaleMargins: {
                top: 0.1,    // 與線圖的上邊距對齊
                bottom: 0.3,  // 與價量圖的下邊距對齊，保持 0.3 的距離
            },
            //tickMarkFormatter: (price) => {
            //    // 僅顯示在 10 到 20 之間的價格刻度
            //    return price >= 740 && price <= 1080 ? `$${price.toFixed(2)}` : '';
            //},
        },
        localization: {
            //priceFormatter: price => `${price.toFixed(0)}`, //價格格式, 之後再依實際處理
            timeFormatter: time => {
                const date = new Date(time * 1000);
                const year = date.getUTCFullYear();
                const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，所以加1，并确保是两位数
                const day = date.getUTCDate().toString().padStart(2, '0'); // 确保是两位数
                const hours = date.getUTCHours().toString().padStart(2, '0');
                const minutes = date.getUTCMinutes().toString().padStart(2, '0');
                const seconds = date.getUTCSeconds().toString().padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}`;
            }
        }, 
        grid: {
            vertLines: {
                color: '#272727',  // background white => #e0e0e0
                style: 1,          // 垂直網格線的樣式 (虛線)
                visible: true,     // 顯示垂直網格線
                width: 1           // 垂直網格線的寬度
            },
            horzLines: {
                //color: '#e0e0e0',
                color: '#272727',
            },
        },
        crosshair: {
            vertLine: {
                visible: true,
                width: 1,
                //color: 'rgba(0, 0, 0, 0.5)',
            },
            horzLine: {
                visible: true,
                width: 1,
                //color: 'rgba(0, 0, 0, 0.5)',
            },            
        },
    },
    intervalColors : {   //用在線圖
        '1D': '#2962FF',
        '1W': 'rgb(225, 87, 90)',
        '1M': 'rgb(242, 142, 44)',
        '1Y': 'rgb(164, 89, 209)',
    },
};

export default config;


// 设置价格标签的位置
//chart.priceScale('right').applyOptions({
//    mode: 1, // 0 - normal, 1 - log, 2 - percentage, 3 - indexedTo100
//    position: 'right', // 'right' or 'left'
//    borderVisible: false,
//});
// 显示左侧价格标签
//chart.priceScale('left').applyOptions({
//    visible: true,
//    borderVisible: false,
//});
// 为时间轴标签添加自定义样式
//const customTimeLabels = document.querySelectorAll('.custom-time-label');
//customTimeLabels.forEach(label => {
//    label.style.whiteSpace = 'pre-line';
//});
